const SYMBOLS: Record<string, string> = { VND: '₫', USD: '$', EUR: '€', JPY: '¥' };

/** Format a contract amount by currency, e.g. `1,500,000 ₫` (legacy `formatCurrency`). */
export function formatContractAmount(amount: number, currency: string): string {
  const symbol = SYMBOLS[currency] ?? currency;
  const digits = currency === 'VND' || currency === 'JPY' ? 0 : 2;
  const value = (Number(amount) || 0).toLocaleString('en-US', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
  return `${value} ${symbol}`;
}
